// the anonymous ID from Segment - set from the OAuth flow
export const KEY_ACCEPTED_TERMS = 'loom_accepted_terms';
export const KEY_ANON_ID = 'loom_anon_id';
export const KEY_ANON_COMMENT = 'loom_anon_comment';
export const KEY_ANON_COMMENT_NAME = 'loom_anon_comment_name';
export const KEY_APP_SOURCE = 'loom_app_source';
export const KEY_DEVICE_ID = 'loom_device_id';
export const KEY_THEATER_MODE = 'loom_theater_mode';
export const KEY_LOOM_SESSION_ID = 'loom_session_id';
export const KEY_REFERRAL_VIDEO = 'loom_referral_video';
export const KEY_REFERRER_PARTNER_ID = 'loom_referrer_partner_id';
export const KEY_OAUTH_STATE = 'loom_oauth_state';
export const KEY_GA_CLIENT_ID = '_ga';
export const KEY_ROLE = 'role';
export const KEY_SIGNUP_SOURCE = 'loom_signup_source';
export const VAL_PREVIEW_ADMIN = 'admin';
export const KEY_OAUTH_FOR_IOS = 'loom_oauth_for_ios';
export const DASHBOARD_SIDEBAR_IS_COLLAPSED = 'dashboard_sidebar_is_collapsed';

// analytics.js/segment specific anonymous id
export const KEY_AJS_ANON_ID = 'ajs_anonymous_id';

// Set by the load balancer. If you change here, you must change here too:
// https://github.com/loomhq/cookbooks/blob/master/haproxy-loom/recipes/configure.rb
// https://github.com/loomhq/chrome-extension/blob/staging/src/js/constants/cookies.js
export const KEY_RECORDER_IP = 'loom_recorder_server_ip';
